// /var/www/aesirerp_lp/frontend/src/components/Header.tsx
'use client';

import { useState, useEffect } from 'react';
import Image from 'next/image';
import Link from 'next/link';
import { usePathname } from 'next/navigation'; // <--- IMPORTANTE: Hook para saber a rota atual
import { Menu, X } from 'lucide-react';
import styles from './Header.module.css';

const navLinks = [
  { href: '#inicio', label: 'Início' },
  { href: '#modulos', label: 'Módulos' },
  { href: '#parceiros', label: 'Parceiros' },
  { href: '#depoimentos', label: 'Depoimentos' },
];

export function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [hasScrolled, setHasScrolled] = useState(false);
  const pathname = usePathname(); // <--- Pega a página atual (ex: '/termos')

  useEffect(() => {
    const handleScroll = () => setHasScrolled(window.scrollY > 10);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Função auxiliar para resolver o link correto
  const getLinkHref = (href: string) => {
    // Se o link já é externo (http) ou absoluto, não mexe
    if (href.startsWith('http') || href.startsWith('/')) return href;
    
    // Se for âncora (#) e NÃO estiver na home, adiciona a barra antes (/#inicio)
    // Isso força o Next.js a ir para a home e rolar até a seção
    if (href.startsWith('#') && pathname !== '/') {
      return `/${href}`;
    }
    
    return href;
  };

  return (
    <header className={`${styles.header} ${hasScrolled ? styles.scrolled : ''}`}>
      <nav className={styles.nav}>
        {/* Logo sempre manda para a raiz / */}
        <Link href="/" className={styles.logo}>
          <Image src="/assets/images/logo.png" alt="Logo Aesir ERP" width={40} height={40} />
          <span>Aesir ERP</span>
        </Link>
        
        {/* Navegação Desktop */}
        <ul className={styles.desktopNav}>
          {navLinks.map((link) => (
            <li key={link.href}>
              <Link href={getLinkHref(link.href)}>
                {link.label}
              </Link>
            </li>
          ))}
        </ul>

        {/* Botões de Ação */}
        <div className={styles.desktopActions}>
          <a href="https://aesirerp.com/login" className={styles.loginBtn}>
            Entrar
          </a>
          <a href="https://aesirerp.com/register" className={styles.registerBtn}>
            Criar Conta Grátis
          </a>
        </div>

        <button onClick={() => setIsMenuOpen(!isMenuOpen)} className={styles.mobileMenuButton}>
          {isMenuOpen ? <X size={32} /> : <Menu size={32} />}
        </button>
      </nav>

      {/* Menu Mobile */}
      {isMenuOpen && (
        <div className={styles.mobileMenu}>
          <ul>
            {navLinks.map((link) => (
              <li key={link.href}>
                <Link 
                  href={getLinkHref(link.href)} 
                  onClick={() => setIsMenuOpen(false)}
                >
                  {link.label}
                </Link>
              </li>
            ))}
            
            <li style={{ borderTop: '1px solid #f0f0f0', marginTop: '10px', paddingTop: '15px' }}>
              <a 
                href="https://aesirerp.com/privacidade" 
                style={{ fontSize: '0.85rem', color: '#666', textDecoration: 'none' }}
                onClick={() => setIsMenuOpen(false)}
              >
                Política de Privacidade
              </a>
            </li>

            <div className={styles.mobileActions}>
              <a href="https://aesirerp.com/login" className={styles.loginBtn}>Entrar</a>
              <a href="https://aesirerp.com/register" className={styles.registerBtn}>Criar Conta</a>
            </div>
          </ul>
        </div>
       )}
    </header>
  );
}